import { render } from "./OrderRemoval.vue?vue&type=template&id=309ed72c"
import script from "./OrderRemoval.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderRemoval.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/lasource-2023/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/cartes-cadeaux/components/OrderRemoval.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "309ed72c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('309ed72c', __exports__)) {
    console.log('reload')
    api.reload('309ed72c', __exports__)
  }
  
  module.hot.accept("./OrderRemoval.vue?vue&type=template&id=309ed72c", () => {
    console.log('re-render')
    api.rerender('309ed72c', render)
  })

}


export default __exports__